import script from "./InviteFriend.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteFriend.vue?vue&type=script&setup=true&lang=js"

import "./InviteFriend.vue?vue&type=style&index=0&id=b9d4dd24&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9d4dd24"]])

export default __exports__